export function normalizeProjectId(projectId) {
  if (projectId == null || projectId === "") return "";
  if (typeof projectId === "object") {
    const id = projectId._id ?? projectId.id;
    return id != null ? String(id) : "";
  }
  return String(projectId);
}

export function getStatusLabel(status) {
  if (!status) return "—";
  if (status === "done") return "Reviewed";
  const labels = {
    new: "New",
    in_review: "In review",
    reviewed: "Reviewed",
    invoiced: "Invoiced",
  };
  return labels[status] ?? status;
}

export function getStatusBadgeClass(status) {
  if (status === "invoiced") return "bg-green-700 text-white";
  if (status === "reviewed" || status === "done") return "bg-green-100 text-green-800";
  if (status === "in_review") return "bg-amber-100 text-amber-800";
  return "bg-gray-100 text-gray-800";
}

export function getBillingLabel(decision) {
  if (!decision) return "—";
  const labels = {
    included: "Included in price",
    extra: "Bill extra",
    not_billable: "Not billable",
    inherit: "Not set",
    fixed: "Included in price",
    hide_from_project: "Hide from project",
  };
  return labels[decision] ?? "—";
}

/** Line items visible for project/invoice totals (excludes hide_from_project) */
export function getVisibleLineItems(lineItems) {
  return (lineItems || []).filter((li) => li.billingDecision !== "hide_from_project");
}

export function getVisibleLineItemCount(lineItems) {
  return getVisibleLineItems(lineItems).length;
}

export function getVisibleLineItemSum(lineItems) {
  return getVisibleLineItems(lineItems).reduce((sum, li) => sum + (li.net ?? 0), 0);
}

export function hasPriceDiff(inv) {
  const totalNet = inv?.totals?.net ?? inv?.net;
  if (totalNet == null) return !!inv?.hasPriceDiff;
  if (inv?.hasPriceDiff != null) return !!inv.hasPriceDiff;
  const lineSum = getVisibleLineItemSum(inv?.lineItems);
  return Math.abs(Number(totalNet) - lineSum) > 0.01;
}

export function confidenceOpensReview(inv) {
  return hasPriceDiff(inv) || !!inv?.needsReview;
}
